import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useStatRegionsStore = createAnalyticsStore(
  "countryStatRegions",
  "Analytics/top/city/:projectId"
);